<template>
  <div>
<!--    <ul class="overrall-right-bar">-->
<!--      <li :class="expand ? 'expand' : 'collapse'" @click="toggleRight">-->
<!--        <i v-if="expand" class="el-icon-arrow-right"></i>-->
<!--        <i v-else class="el-icon-arrow-left"></i>-->
<!--      </li>-->
<!--      <li v-if="expand" @click="showIm">-->
<!--        <i class="el-icon-s-comment"></i>-->
<!--        <span>{{ $t("im.im1") }}</span>-->
<!--      </li>-->
<!--    </ul>-->
    <div class="im-content-wrap" v-if="imVisible && !loading">
      <div class="header flex-row">
        <img class="logo-img" src="../../assets/images/favicon.png" alt="" />
        <div class="flex-column">
          <h3>{{ $t("newMsg.mess77") }}</h3>
          <span>{{ $t("im.im1") }}</span>
        </div>
        <i @click="closeIm" class="el-icon-close im-close"></i>
      </div>
      <div class="im-content" id="imContent">
        <div class="" v-for="item in msgList" :key="item.timestamp">
          <!-- 禁止使用=== 全等  对方消息-->
          <div class="flex-row" v-if="item.fromId != msgData.fromId">
            <el-avatar style="margin-right: 5px; display: flex;" :size="30">
              <img style="margin: auto" src="../../assets/images/favicon.png" alt="" />
            </el-avatar>
            <div>
              <p class="msg-box-time"></p>
              <p class="msg-box-text-left" v-if="item.messageType === '0'">
                {{ item.content }}
              </p>
              <p class="msg-box-image msg-box-border-left cursor" v-if="item.messageType === '1'">
                <el-image
                  @click="onView(jsonObj(item.extend, 'url'))"
                  style="width: auto; height: auto"
                  :src="jsonObj(item.extend, 'url')"
                  fit="fill"
                />
              </p>
              <p class="msg-box-text-left msg-box-border-left" v-if="item.messageType === '2'">
                <ws-downfile :url="jsonObj(item.extend, 'url')" :name="jsonObj(item.extend, 'fileName')">
                  <i class="el-icon-download"></i>
                  {{ jsonObj(item.extend, "fileName") }}
                </ws-downfile>
              </p>
            </div>
            <div class="flex-grow" style="min-width: 20%"></div>
          </div>
          <div style="padding: 5px"></div>
          <!-- 我方消息 -->
          <div class="flex-row" v-if="item.fromId == msgData.fromId">
            <div class="flex-grow" style="min-width: 20%"></div>
            <div>
              <p class="msg-box-time"></p>
              <p class="msg-box-text-right" v-if="item.messageType === '0'">
                {{ item.content }}
              </p>
              <p class="msg-box-image msg-box-border-right cursor" v-if="item.messageType === '1'">
                <el-image
                  @click="onView(jsonObj(item.extend, 'url'))"
                  style="width: auto; height: auto"
                  :src="jsonObj(item.extend, 'url')"
                  fit="fill"
                />
              </p>
              <p class="msg-box-text-right msg-box-border-right" v-if="item.messageType === '2'">
                <ws-downfile :url="jsonObj(item.extend, 'url')" :name="jsonObj(item.extend, 'fileName')">
                  <i class="el-icon-download"></i>
                  {{ jsonObj(item.extend, "fileName") }}
                </ws-downfile>
              </p>
              <!--html片段-->
              <!-- <div v-if="item.messageType === '3'" class="right-im-box">
                <div class="zcl-im">
                  <div class="zcl-l">
                    <img :src="item.extend.pictureUrl" alt="" />
                  </div>
                  <div class="zcl-r">
                    <div class="p1">{{ item.extend.goodsName }}</div>
                    <div class="p2">{{ $t("wslang189") }}：{{ item.extend.price }}</div>
                  </div>
                </div>
              </div> -->
            </div>
            <el-avatar style="margin-left: 5px" :size="30">
              <span>{{ userName }}</span>
              <!-- <img src="../../assets/images/imUser.png" alt="" /> -->
            </el-avatar>
            <!-- <el-avatar style="margin: 0 5px" :size="30" :src="msgData.fromAvatar" /> -->
          </div>
        </div>
      </div>
      <div class="im-box">
        <div class="im-upload flex-row">
          <el-upload
            class="editor-slide-upload"
            action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com"
            :show-file-list="false"
            :data="imgDataObj"
            :file-list="imgFileList"
            :on-success="handleImgSuccess"
            :before-upload="beforeImgUpload"
            :accept="imgFormat"
          >
            <i class="el-icon-picture-outline"></i>
          </el-upload>
          <el-upload action="/" :http-request="uploadFile" :accept="fileFormat" :show-file-list="false">
            <i class="el-icon-folder-opened"></i>
          </el-upload>
          <div v-loading="uploadLoading" class="upload-loading" element-loading-spinner="el-icon-loading"></div>
        </div>
        <div class="im-send-box">
          <el-input
            v-model="messageContent"
            class="im-send-input"
            type="textarea"
            resize="none"
            style="border: none; background: none"
            @keyup.enter="mineSend()"
          ></el-input>
        </div>
        <div class="im-send-btn-box">
          <el-button class="send-btn" @click="mineSend()">{{ $t("im.im2") }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getImUser, getMessageList } from "./apiIm";
import { WsRequest } from "./WsRequest";
import Oss from "../../assets/js/oss";
import wsDownfile from "./ws-downfile.vue";

export default {
  components: {
    wsDownfile,
  },
  data() {
    return {
      expand: true,
      imVisible: false,
      sub: {
        imageShow: false, //图片显示
        imageUrl: undefined, //图片url
      },
      userInfo: {},
      msgData: {
        chatId: undefined, //对方id
        fromId: undefined, //我的id
      },
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      listObj: {},
      imgFileList: [],
      ws: null,
      messageContent: "",
      msgList: [],
      imgFormat: ".jpg, .jpeg, .png, .gif",
      fileFormat: ".doc, .docx, .xls, .xlsx, .pdf, .gif, .exe, .msi, .swf, .sql, .apk, .psd",
      loading: false,
      uploadLoading: false,
    };
  },
  computed: {
    userName() {
      return this.userInfo.userName.slice(0, 2);
    },
  },
  methods: {
    toggleRight() {
      this.expand = !this.expand;
    },
    showIm() {
      this.imVisible = !this.imVisible;
    },
    closeIm() {
      this.imVisible = false;
    },
    jsonObj(json, key) {
      if (json) {
        if (typeof json === "string") {
          let a = JSON.parse(json);
          return a[key];
        } else {
          return json[key];
        }
      } else {
        return "";
      }
    },
    onView(url) {
      this.sub.imageUrl = url;
      this.sub.imageShow = true;
    },
    async getSystemUser() {
      this.loading = true;
      //获取客户信息
      const { data: res } = await getImUser({});
      if (res.code === 200) {
        this.msgData.fromId = this.userInfo?.userId;
        this.msgData.chatId = res.data?.user?.userId;

        let params = {
          chatId: this.msgData.chatId,
          fromId: this.msgData.fromId,
          fromType: "0",
        };
        const { data: resMsg } = await getMessageList(params);
        if (resMsg.code === 200) {
          this.msgList = resMsg?.data?.records || resMsg?.data;
          this.setScroll();
        }
        this.loading = false;
        this.initMsg();
      }
    },
    initMsg() {
      const token = window.sessionStorage.getItem("tokenValue");
      this.ws.init(process.env.VUE_APP_VITE_WSS + "?token=" + token);
      this.ws.onmessage = (message) => {
        //群聊里面，自己发的消息不再显示
        if (this.msgData.fromId === message.fromId) {
          //当前为自己发送的消息
          this.msgList.push(message);
        } else {
          this.readMessage();
          this.msgList.push(message);
        }
        this.setScroll();
      };
    },
    setScroll() {
      setTimeout(() => {
        let imContent = document.getElementById("imContent");
        let a = 295 + Number(imContent?.scrollHeight);
        // imContent?.scrollIntoView({ behavior: "smooth", block: "end" })
        imContent?.scrollTo(0, a);
      }, 200);
    },
    readMessage() {
      let receipt = {
        chatId: this.msgData.chatId,
        userId: this.userInfo.userId,
        timestamp: new Date().getTime(),
        type: "0", //私聊0，群聊1
      };
      this.ws.sendRead(receipt);
    },
    onSendImage(res) {
      let extend = {
        fileName: res?.originalFilename,
        url: res.url,
      };
      this.mineSend("1", extend);
    },
    async uploadFile(file) {
      this.uploadLoading = true;
      let formdata = new FormData();
      formdata.append("file", file.file);
      const { data: res } = await this.$http.post("cmUser/message/uploadFile", formdata, { headers: { isCurLoad: true } });
      this.uploadLoading = false;
      if (res.code === 200) {
        let { fileName, filePath } = res.data;
        let extend = {
          fileName,
          url: filePath,
        };
        this.mineSend("2", extend);
      } else {
        this.$message.error(this.$t("im.im3"));
      }
    },
    async getUserInfo() {
      const { data: res } = await this.$http.get("customer/getCustomerInfo");
      this.userInfo = res.data;
    },
    handleImgSuccess(_, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
      this.$nextTick(() => {
        let extend = {
          fileName: file.name,
          url: this.listObj[file.uid].url,
        };
        this.mineSend("1", extend);
      });
    },
    beforeImgUpload(file) {
      this.uploadLoading = true;
      const _self = this;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = ""; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            _self.imgDataObj.policy = response.data.data.policy;
            _self.imgDataObj.signature = response.data.data.signature;
            _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
            _self.imgDataObj.key = response.data.data.dir + "/bad/" + num + "${filename}";
            _self.imgDataObj.dir = response.data.data.dir + "/bad";
            _self.imgDataObj.host = response.data.data.host;
            _self.imgDataObj.timeStamp = num;
            file.timeStamp = num;
            Oss.imgCompress(file, this.listObj, resolve, reject);
          })
          .catch(() => {
            reject(false);
          })
          .finally(() => {
            this.uploadLoading = false;
          });
      });
    },
    mineSend(messageType = "0", extend) {
      if (this.messageContent || extend) {
        let msg = {
          messageType: messageType,
          chatId: this.msgData.chatId,
          fromId: this.msgData.fromId,
          mine: true,
          timestamp: new Date().getTime(),
          content: this.messageContent,
          extend: extend,
          type: "0", //chat.value.type || '111'
        };
        this.ws.sendMessage(msg);
        this.messageContent = undefined;
      }
      this.setScroll();
    },
  },
  beforeDestroy() {
    this.ws.close();
  },
  created() {
    this.ws = new WsRequest();
    this.getUserInfo();
  },
  watch: {
    imVisible(val) {
      if (val) {
        this.getSystemUser();
      } else {
        this.ws.close();
      }
    },
  },
};
</script>
<style scoped lang="less">
.overrall-right-bar {
  position: absolute;
  top: 50%;
  right: 0;
  z-index: 9000;
  cursor: pointer;
  li {
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #3a4255;
    color: #fff;
    padding: 10px;
    span {
      width: 30px;
      margin-top: 10px;
    }
    .el-icon-s-comment {
      font-size: 22px;
    }
  }
  .expand {
    padding: 10px 10px 0 10px;
  }
  .collapse {
    padding: 20px 0;
  }
}
::v-deep .el-badge__content.is-fixed {
  top: -2px;
}
.im-box {
  display: flex;
  flex-direction: column;
  padding: 10px;
  .im-upload {
    i {
      font-size: 20px;
      margin-right: 10px;
    }
  }
  ::v-deep .el-loading-spinner {
    margin-top: -12px;
  }
}
// .right-im-box {
//   width: 320px;
//   margin-top: 75px;
//   position: relative;
// }
// .zcl-im {
//   position: absolute;
//   border-radius: 15px;
//   top: -86px;
//   left: 0;
//   width: 100%;
//   padding: 10px 20px 10px 10px;
//   box-sizing: border-box;
//   display: flex;
//   align-items: center;
//   background-color: rgba(225, 225, 225, 0.9);
//   z-index: 99;
//   .zcl-l {
//     img {
//       width: 50px;
//       height: 60px;
//       margin-top: 2px;
//     }
//   }
//   .zcl-r {
//     margin-left: 15px;
//     color: #000;
//     margin-top: -5px;
//     .p1 {
//       line-height: 1.4em;
//       display: -webkit-box;
//       overflow: hidden;
//       text-overflow: ellipsis;
//       -webkit-line-clamp: 2; /* 限定最多显示两行 */
//       -webkit-box-orient: vertical;
//     }
//     .p2 {
//       margin-top: 8px;
//       line-height: 1em;
//       color: #ff0000;
//       display: flex;
//       align-items: center;
//       justify-content: space-between;
//       span {
//         color: #ff9900;
//         cursor: pointer;
//       }
//     }
//   }
//   .zcl-icon {
//     position: absolute;
//     top: 12px;
//     right: 8px;
//     cursor: pointer;
//   }
// }

.im-content-wrap {
  width: 360px;
  height: 540px;
  border-radius: 8px;
  overflow: hidden;
  position: absolute;
  background: white;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 9000;
  right: 50px;
  bottom: 0;
  .header {
    background-color: #3a4255;
    color: #fff;
    height: 60px;
    position: relative;
    align-items: center;
    padding-left: 10px;
    .im-close {
      position: absolute;
      right: 5px;
      top: 5px;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .im-content {
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    background-color: #f3f3f3;
    padding: 10px;
  }

  .im-content::-webkit-scrollbar {
    width: 4px;
  }

  .im-content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bababa;
    // -webkit-box-shadow: inset 0 0 5px #3a4255;
    opacity: 0.2;
  }

  // .im-content::-webkit-scrollbar-track {
  //   -webkit-box-shadow: inset 0 0 5px #7ec64732;
  //   border-radius: 0px;
  // }
}

.msg-box-time {
  padding: 5px 0px;
}

.im-icon {
  height: 50px !important;
  width: 50px !important;
  min-width: 50px;
}

.im-send-box {
  height: 100px;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  .im-send-input {
    border: none;
    ::v-deep .el-textarea__inner {
      padding: 0 15px 5px 0;
      border: none;
      height: auto;
    }
    ::v-deep .el-textarea__inner::-webkit-scrollbar {
      width: 4px;
    }
    ::v-deep .el-textarea__inner::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #bababa;
      opacity: 0.2;
    }
  }
}
.im-send-btn-box {
  display: flex;
  justify-content: flex-end;
}

.send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 10px 20px;
  background: #3a4255;
  color: #fff;
}

.msg-box-text-left {
  width: auto;
  height: auto;
  border: 1px solid #fff;
  padding: 5px;
  background-color: #fff;
  color: #000;
  border-radius: 0px 5px 5px 5px;
  word-break: break-word;
  margin-left: 5px;
}

.msg-box-text-right {
  width: auto;
  height: auto;
  border: 1px solid #89d961;
  color: #000;
  background: #89d961;
  padding: 5px;
  border-radius: 5px 0px 5px 5px;
  word-break: break-word;
  margin-right: 5px;
}

.msg-box-files {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  padding: 5px;
}

.msg-box-image {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.msg-box-border-right {
  border-radius: 5px 0px 5px 5px;
}

.msg-box-border-left {
  border-radius: 0px 5px 5px 5px;
}

:deep(.el-avatar) {
  height: 30px;
  min-height: 30px;
  width: 30px;
  min-width: 30px;
}

.flex-row {
  display: flex;
}

.flex-grow {
  flex: 1;
}

.flex-column {
  flex-direction: column;
}

.logo-img {
  width: 35px;
  margin-right: 5px;
}
</style>
